const state={
    preview:false,
}
const getters={}
const actions={}
const mutations={
    setScrollTop(state,v){
        state.preview=v;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}